import React from 'react'
// import { Route, Switch } from 'react-router'
// import Home from '../../../../Home'
// import MakeAdmin from '../Blogs/Admin/MakeAdmin/MakeAdmin'

const Events = () => {
    return (
        <div>
            <h2>Add Events page</h2>
            {/* <Switch>
        <Route exact path={path}>
          <Home></Home>
        </Route>
        <Route path={`${path}/makeAdmin`}>
            <MakeAdmin></MakeAdmin>
        </Route>
      </Switch> */}
        </div>
    )
}

export default Events
